import axios from 'axios'

export const custAxios = () => {
  const instance = axios.create({
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('token-support')}`
    }
  })

  return instance
}
